import $api from "http/index";

const ACADEMIC = "academic/";

export const listSlots = (params) => $api.get(`${ACADEMIC}slots/`, { params });
export const getSlot = (id) => $api.get(`${ACADEMIC}slots/${id}/`);
export const createSlot = (data) => $api.post(`${ACADEMIC}slots/`, data);
export const updateSlot = (id, data) => $api.patch(`${ACADEMIC}slots/${id}/`, data);
export const deleteSlot = (id) => $api.delete(`${ACADEMIC}slots/${id}/`);
export const slotConflicts = (id) => $api.get(`${ACADEMIC}slots/${id}/conflicts/`);
export const bulkCreateSlots = (data) => $api.post(`${ACADEMIC}slots/bulk/`, data);
export const slotsGrid = (params) => $api.get(`${ACADEMIC}slots/grid/`, { params });

export const listSemesters = (params) => $api.get(`${ACADEMIC}semesters/`, { params });
export const getSemester = (id) => $api.get(`${ACADEMIC}semesters/${id}/`);
export const expandSemester = (id) => $api.post(`${ACADEMIC}semesters/${id}/expand/`);

export const listLessons = (params) => $api.get(`${ACADEMIC}lessons/`, { params });
export const rescheduleLesson = (id, data) => $api.post(`${ACADEMIC}lessons/${id}/reschedule/`, data);
export const cancelLesson = (id, data) => $api.post(`${ACADEMIC}lessons/${id}/cancel/`, data);

export const listYears = () => $api.get(`${ACADEMIC}years/`);
export const createYear = (data) => $api.post(`${ACADEMIC}years/`, data);

export const WEEKDAYS = [
  { value: 1, label: "Пн" },
  { value: 2, label: "Вт" },
  { value: 3, label: "Ср" },
  { value: 4, label: "Чт" },
  { value: 5, label: "Пт" },
  { value: 6, label: "Сб" },
  { value: 7, label: "Вс" },
];

export const PAIR_TIMES = [
  { pair_no: 1, starts_at: "08:00", ends_at: "09:20" },
  { pair_no: 2, starts_at: "09:30", ends_at: "10:50" },
  { pair_no: 3, starts_at: "11:00", ends_at: "12:20" },
  { pair_no: 4, starts_at: "13:00", ends_at: "14:20" },
  { pair_no: 5, starts_at: "14:30", ends_at: "15:50" },
  { pair_no: 6, starts_at: "16:00", ends_at: "17:20" },
  { pair_no: 7, starts_at: "17:30", ends_at: "18:50" },
  { pair_no: 8, starts_at: "19:00", ends_at: "20:20" },
];

export const LESSON_TYPES = [
  { value: "lecture", label: "Лекция" },
  { value: "practice", label: "Практика" },
  { value: "seminar", label: "Семинар" },
  { value: "lab", label: "Лаб. работа" },
  { value: "consult", label: "Консультация" },
  { value: "exam", label: "Экзамен" },
  { value: "zachet", label: "Зачёт" },
  { value: "other", label: "Иное" },
];

export const WEEK_PARITIES = [
  { value: "any", label: "Каждую неделю" },
  { value: "odd", label: "Числитель" },
  { value: "even", label: "Знаменатель" },
];
